"use client";

import React from "react";
import styles from "./typography.module.css";

export type TitleSize = "small" | "medium" | "large";

export interface TitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children?: React.ReactNode;
  size?: TitleSize;
  color?: string;
  align?: "center" | "left" | "right";
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span" | "div";
  className?: string;
  style?: React.CSSProperties;
}

export const AppTitle: React.FC<TitleProps> = ({
  children,
  size = "medium",
  color = "var(--color-primary)",
  align = "left",
  as: Component = "h2",
  className = "",
  style,
  ...rest
}) => {
  const resolvedColor =
    color === "primary" ? "var(--color-primary)" : color;

  const sizeClass =
    size === "large"
      ? styles.sizeLarge
      : size === "small"
        ? styles.sizeSmall
        : styles.sizeMedium;

  return (
    <Component
      className={`${styles.title} ${sizeClass} ${className}`.trim()}
      style={{
        textAlign: align,
        ...(resolvedColor ? { color: resolvedColor } : {}),
        ...style,
      }}
      {...rest}
    >
      {children}
    </Component>
  );
};

export const Title = AppTitle;
export default AppTitle;
